import React from 'react'
import { Switch, Route } from 'react-router'

import Normal from './normal'
import TestError from './error'

const Test = () => {
  return (
    <Switch>
      <Route path='/test/error' exact component={TestError} />

      <Route path='/test' exact component={Normal} />
    </Switch>
  )
}

export default Test
